import React, { forwardRef } from 'react';

// Components
import WpIcon from '../../../icon/WpIcon';
import WpButton from '../../../button/WpButton';

type Props = {
  icon: string;
  iconPrefix?: string;
  onClick: () => void;
  active?: boolean;
};

type ForwardedRef = {
  current: HTMLButtonElement;
};

const Control = forwardRef(({ icon, iconPrefix = 'fal', onClick, active }: Props, ref: ForwardedRef) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };
  return (
    <WpButton size="xs" color="gray" variant={active ? 'primary' : 'tertiary'} onClick={handleClick} ref={ref} square>
      <WpIcon size="sm" name={icon} prefix={iconPrefix} />
    </WpButton>
  );
});

export default Control;
